import {
  autoUpdate,
  flip,
  offset,
  ReferenceType,
  size,
  useDismiss,
  useFloating,
  UseFloatingReturn,
  useInteractions,
} from '@floating-ui/react';
import { useCallback, useState } from 'react';

// TODO: create common floating type...

export type UseFloatingMenuReturn = {
  openFloatingMenu: () => void;
  closeFloatingMenu: () => void;
  showFloatingMenu: boolean;
  floatingMenuGetReferenceProps: ReturnType<
    typeof useInteractions
  >['getReferenceProps'];
  getFloatingMenuProps: ReturnType<typeof useInteractions>['getFloatingProps'];
  floatingResult: UseFloatingReturn<ReferenceType>;
};

export function useFloatingMenu(): UseFloatingMenuReturn {
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);

  const openFloatingMenu = useCallback(() => setShowFloatingMenu(true), []);
  const closeFloatingMenu = useCallback(() => setShowFloatingMenu(false), []);

  // TODO: add over the top when an image is being edited.
  const floatingResult = useFloating({
    middleware: [
      offset(6),
      flip({
        padding: 5,
        fallbackPlacements: ['top'],
      }),
      size({
        apply({ elements, rects }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`,
          });
        },
      }),
    ],
    strategy: 'fixed',
    placement: 'bottom',
    open: showFloatingMenu,
    onOpenChange: setShowFloatingMenu,
    whileElementsMounted: autoUpdate,
  });

  const context = floatingResult.context;
  const { getReferenceProps, getFloatingProps } = useInteractions([
    useDismiss(context),
  ]);

  return {
    openFloatingMenu,
    closeFloatingMenu,
    floatingMenuGetReferenceProps: getReferenceProps,
    getFloatingMenuProps: getFloatingProps,
    floatingResult,
    showFloatingMenu: showFloatingMenu,
  };
}
